const topBg = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let sW = window.innerWidth;


    {
      const sec = document.getElementById('jsSecInfo');
      const wrap = sec.querySelector('.js-bg-wrap');
      const canvas = wrap.querySelector('.js-canvas');

      let granimInstance = new Granim({
        element: canvas,
        direction: "top-bottom",
        opacity: [1, 1],
        isPausedWhenNotInView: true,
        states: {
          "default-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#ffffff", "#95b2c6"],
              ["#7991a9", "#82777b"]
            ]
          }
        }
      });
    }


    {
      const sec = document.getElementById('jsSecBg2');
      const wrap = sec.querySelector('.js-bg-wrap');
      const canvas = wrap.querySelector('.js-canvas');

      let granimInstance = new Granim({
        element: canvas,
        direction: "top-bottom",
        opacity: [1, 1],
        isPausedWhenNotInView: true,
        states: {
          "default-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          }
        }
      });
    }



  }
})();
export default topBg;